import React, { useEffect, useState } from "react";
import Ornament from "@/components/Ornament";
import Reveal from "@/components/Reveal";

const IMAGES = [
  {
    src: "/images/church.png",
    alt: "Watercolour of St Peter & St Paul's Church, Blockley",
    caption: "The Ceremony",
    place: "St Peter & St Paul's Church",
  },
  {
    src: "/images/manor.png",
    alt: "Watercolour of Foxhill Manor",
    caption: "The Reception",
    place: "Foxhill Manor",
  },
];

const Gallery = () => {
  const [idx, setIdx] = useState(null);

  const close = () => setIdx(null);
  const prev = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i === null ? null : (i - 1 + IMAGES.length) % IMAGES.length));
  };
  const next = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i === null ? null : (i + 1) % IMAGES.length));
  };

  useEffect(() => {
    const onKey = (e) => {
      if (idx === null) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    if (idx !== null) document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [idx]);

  return (
    <section id="gallery" className="section gallery" data-testid="section-gallery">
      <Ornament />
      <Reveal as="h2" className="script-h2">
        Moments
      </Reveal>
      <Reveal as="p" className="muted center subtle">
        A little of what awaits you in the Cotswolds.
      </Reveal>

      <div className="gallery-grid">
        {IMAGES.map((im, i) => (
          <Reveal
            key={im.src}
            className="g-tile"
            delay={(i % 2) * 120}
          >
            <button
              className="g-btn"
              onClick={() => setIdx(i)}
              aria-label={`Open ${im.caption}`}
              data-testid={`gallery-tile-${i}`}
            >
              <img src={im.src} alt={im.alt} loading="lazy" />
              <span className="g-plus">+</span>
            </button>
            <div className="g-caption">
              <span className="g-caption-eyebrow">{im.caption}</span>
              <span className="g-caption-place">{im.place}</span>
            </div>
          </Reveal>
        ))}
      </div>

      {idx !== null && (
        <div className="lightbox" onClick={close} data-testid="lightbox">
          <button className="lb-close" onClick={close} aria-label="Close">
            ×
          </button>
          <button className="lb-nav lb-prev" onClick={prev} aria-label="Previous">
            ‹
          </button>
          <img
            className="lb-img"
            src={IMAGES[idx].src}
            alt={IMAGES[idx].alt}
            onClick={(e) => e.stopPropagation()}
          />
          <button className="lb-nav lb-next" onClick={next} aria-label="Next">
            ›
          </button>
          <div className="lb-caption">
            <span className="lb-caption-eyebrow">{IMAGES[idx].caption}</span>
            <span className="lb-caption-place">{IMAGES[idx].place}</span>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
